import * as React from "react";
import s from "./cta.scss";
import { ctaContent } from "./content";
import { replacePlaceholders } from "../../utils/replace-placeholders";

interface CtaProps {
	year: number;
}

export function Cta({ year }: CtaProps) {
	const nextYear = year + 1;

	return (
		<section className={s.cta}>
			<div className={s.ctaOverlay} />
			<div className={s.ctaContent}>
				<h2>{replacePlaceholders(ctaContent.title, { year })}</h2>
				<p>{replacePlaceholders(ctaContent.subtitle, { nextYear })}</p>
				{/* <button className={s.ctaButton}>Ver Dashboard Completo</button> */}
			</div>
		</section>
	);
}
